import { Actions, AppContext } from "@Context/common/general/context";
import { useContext } from "react";

interface AnalyticsEventData {
  [key: string]: any;
}

interface UseAnalyticsReturn {
  track: (eventType: string, data?: AnalyticsEventData, onSuccess?: () => void) => void;
}

/**
 * Custom hook for simplified analytics event tracking
 *
 * @example
 * const { track, trackSubscriptionEvent } = useAnalytics();
 *
 * // Simple event with no data
 * track(AnalyticsEvents.user_login);
 *
 * // Event with data
 * track(AnalyticsEvents.payment_success, { price_id: 'price_123', amount: 49.99 });
 */
export const useAnalytics = (): UseAnalyticsReturn => {
  const { dispatch } = useContext(AppContext);

  const track = (eventType: string, data?: AnalyticsEventData, onSuccess?: () => void) => {
    dispatch({
      type: Actions.AppActions.AnalyticsEvent,
      payload: {
        type: eventType,
        data: data || {},
      },
      onSuccess,
    });
  };

  // TODO: Add convenience methods for common event patterns (events that are used in multiple places)

  return {
    track,
  };
};

export default useAnalytics;
